import {
    getPortInfoByVessels,
    getShVesselsInfo,
    getNbVesselsInfo,
    getExitPortByDepPort,
} from "@/api/assistant";
import { apiCallback } from "@/utils";
import { getCustomsByIEPort } from "@/views/Assistant/index";

// 义乌市场采购
const state = {
    // 船名航次港口-->出口口岸,离境口岸信息,截止时间
    portShipData: {},
    /** 品名编辑表格：分页记忆（此模块会自动持久化到本地） */
    goodsEditPagination: {
        pageSize: 1000,
    },
};

const mutations = {
    SET_PORT_SHIP_DATA(state, data) {
        const { key, value } = data;
        state.portShipData[key] = value;
    },
    SET_PORT_SHIP_DATA_CLOSE_TIME(state, data) {
        const { key, value } = data;
        state.portShipData[key].closeTime = value;
    },
    SET_PORT_SHIP_DATA_IS_SHOW_CLOSE_TIPS(state, data) {
        const { key, value } = data;
        state.portShipData[key].isShowCloseTips = value;
    },
    SET_PORT_SHIP_EMPTY_DATA(state) {
        state.portShipData = {};
    },
    SET_GOODS_EDIT_PAGINATION(state, payload) {
        const next = payload || {};
        const pageSize = Number(next.pageSize) || 1000;
        state.goodsEditPagination = {
            ...state.goodsEditPagination,
            pageSize: pageSize > 0 ? pageSize : 1000,
        };
    },
};

const actions = {
    getShipPortValidate(
        { state, commit },
        {
            vesselName, // 船名
            voyageNo, // 航次
            departurePort, // 离境口岸
            iEPort, // 出口口岸
            needShipScheduleValidate = false,
        },
    ) {
        return new Promise(async (resolve, reject) => {
            let searchType = getCustomsByIEPort(iEPort);
            const setKey = `${vesselName}-${voyageNo}-${searchType}`.replaceAll(
                " ",
                "",
            );
            const getCloseTime = () => {
                return new Promise(async (resolve, reject) => {
                    const curData = state.portShipData[setKey];
                    const func =
                        searchType === "NB"
                            ? getNbVesselsInfo
                            : getShVesselsInfo;
                    const isNeedFetchCloseTime =
                        curData &&
                        curData.departurePortName &&
                        !curData.closeTime;
                    if (isNeedFetchCloseTime) {
                        const res = await func({
                            vesselName,
                            voyage: voyageNo,
                        });
                        const data = apiCallback(res) || {};
                        const { closeTime = "-" } = data;
                        const curDate = new Date();
                        const closeDate = new Date(closeTime);
                        commit("SET_PORT_SHIP_DATA_CLOSE_TIME", {
                            key: setKey,
                            value: closeTime,
                        });
                        if (closeDate > curDate) {
                            // 三天以内
                            const isNeedShowTips =
                                (closeDate - curDate) / 1000 / 3600 < 72;
                            commit("SET_PORT_SHIP_DATA_IS_SHOW_CLOSE_TIPS", {
                                key: setKey,
                                value: isNeedShowTips,
                            });
                        }
                        resolve(true);
                    }
                    resolve(true);
                });
            };
            if (vesselName && voyageNo) {
                try {
                    const curData = state.portShipData[setKey];
                    if (curData) {
                        if (!needShipScheduleValidate) {
                            resolve(curData);
                        } else {
                            // 查一下截止时间
                            await getCloseTime();
                            resolve(true);
                        }
                        return;
                    }
                    // 根据船名航次查出口口岸和离境口岸
                    const res = await getPortInfoByVessels({
                        vesselName,
                        voyage: voyageNo,
                        type: searchType,
                    });
                    const data = apiCallback(res);
                    const {
                        departurePort: departurePortName = "-",
                        departurePortCode = "-",
                        exitCustoms = "-",
                        exitCustomsCode = "",
                    } = data || {};
                    commit("SET_PORT_SHIP_DATA", {
                        key: setKey,
                        value: {
                            departurePortCode,
                            exitCustomsCode,
                            exitCustoms,
                            departurePortName,
                        },
                    });
                    if (needShipScheduleValidate) {
                        await getCloseTime();
                    }
                    resolve(true);
                } catch (e) {
                    console.error("获取港口信息失败", e);
                    resolve(false);
                }
            } else {
                resolve(false);
            }
        });
    },
    setEmptyPortShipData({ commit }) {
        commit("SET_PORT_SHIP_EMPTY_DATA");
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
